import api from "./authService.js";

export const freezerService = {
  async getProductsByContainer(containerId) {
    const response = await api.get(`/freezer/products/${containerId}`);
    return response.data;
  },

  async addProduct(productData) {
    const adaptedData = {
      name: productData.label,
      category: productData.category,
      quantity: productData.units,
      containerId: productData.container_id,
      details: {
        weight: productData.weight,
        portions: productData.portions,
        freezeDate: productData.freeze_date,
        dlc: productData.dlc,
        additionalDetails: productData.details,
      },
    };

    const response = await api.post("/freezer/products", adaptedData);
    return response.data;
  },

  async updateProduct(productId, updates) {
    // S'assurer que les valeurs numériques sont bien des nombres
    const adaptedData = {
      name: updates.name,
      category: updates.category,
      quantity: Number(updates.quantity),
      containerId: updates.containerId,
      details: {
        weight: Number(updates.details.weight) || 0,
        portions: Number(updates.details.portions) || 1,
        freezeDate: updates.details.freezeDate,
        dlc: updates.details.dlc,
        additionalDetails: updates.details.additionalDetails || "",
      },
    };

    const response = await api.put(
      `/freezer/products/${productId}`,
      adaptedData
    );
    return response.data;
  },

  async deleteProduct(productId) {
    await api.delete(`/freezer/products/${productId}`);
  },
};
